import { ManageAccounts, Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import { useState } from 'react';
import { Button, Modal, Box, CircularProgress, Typography, Grid, Autocomplete, Select, MenuItem, Checkbox, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import { successAlert } from 'ui-component/Toasts';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const UpdateaddressListRecord = ({ addressList, fetchaddressesRecord, cityNames }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [fromAddressName, setfromAddressName] = useState(addressList.fromAddressName ? addressList.fromAddressName : '');
    const [toAddressName, settoAddressName] = useState(addressList.toAddressName ? addressList.toAddressName : '');
    const [fromCityName, setfromCityName] = useState(addressList.fromCityName ? addressList.fromCityName : '');
    const [toCityName, settoCityName] = useState(addressList.toCityName ? addressList.toCityName : '');
    const [amount, setamount] = useState(addressList.amount ? addressList.amount : '');
    const [updateActive, setupdateActive] = useState(addressList.active ? addressList.active : false);

    const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
    const [updateaddressListLoading, setUpdateaddressListLoading] = useState(false);

    const submitInsertTasklist = async () => {
        setUpdateBtnDisabled(true);
        setTimeout(() => {
            setUpdateBtnDisabled(false);
        }, 3000);
        setUpdateaddressListLoading(true);
        try {
            const res = await axiosInstance.put(
                '/Address',
                {
                    id: addressList.id,
                    fromAddressName: fromAddressName,
                    toAddressName: toAddressName,
                    fromCityName: fromCityName,
                    toCityName: toCityName,
                    active: updateActive,
                    amount: amount
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Address Updated successfully.');
                fetchaddressesRecord();
                setOpen(false);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateaddressListLoading(false);
        }
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ManageAccounts />
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {updateaddressListLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Update Drivers
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            From Address Name :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={fromAddressName}
                                            onChange={(e) => setfromAddressName(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            To Address Name :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={toAddressName}
                                            onChange={(e) => settoAddressName(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            From City Name :
                                        </Typography>
                                        <Autocomplete
                                            freeSolo
                                            value={fromCityName}
                                            onChange={(event, newValue) => {
                                                setfromCityName(newValue);
                                            }}
                                            inputValue={fromCityName}
                                            onInputChange={(event, newInputValue) => {
                                                setfromCityName(newInputValue);
                                            }}
                                            id="controllable-states-demo"
                                            options={cityNames.map((city) => ({ label: city.name, value: city.id }))}
                                            sx={{ width: 170 }}
                                            renderInput={(params) => <TextField {...params} />}
                                            disableClearable
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            To City Name :
                                        </Typography>
                                        <Autocomplete
                                            freeSolo
                                            value={toCityName}
                                            onChange={(event, newValue) => {
                                                settoCityName(newValue);
                                            }}
                                            inputValue={toCityName}
                                            onInputChange={(event, newInputValue) => {
                                                settoCityName(newInputValue);
                                            }}
                                            id="controllable-states-demo"
                                            options={cityNames.map((city) => ({ label: city.name, value: city.id }))}
                                            sx={{ width: 170 }}
                                            renderInput={(params) => <TextField {...params} />}
                                            disableClearable
                                        />
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Active :
                                        </Typography>
                                        <Checkbox
                                            checked={updateActive}
                                            onChange={(e) => setupdateActive(e.target.checked)} // Use checked value directly
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Amount :
                                        </Typography>
                                        <input
                                            type="number"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={amount}
                                            onChange={(e) => setamount(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => submitInsertTasklist()}
                            disabled={updateBtnDisabled}
                        >
                            Update
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default UpdateaddressListRecord;
